import { FunctionComponent } from "react";
import { StyledIcon, StyledInfo } from "./info.styles";
import { faTriangleExclamation } from "./icon-library";

interface InfoProps {
  children: any;
}

const Info: FunctionComponent<InfoProps> = ({ children }) => {
  return (
    <StyledInfo>
      <StyledIcon icon={faTriangleExclamation} />
      {children}
    </StyledInfo>
  );
};

export default Info;
